export const numberFormats = {
  "en-US": {
    // A named format
    mainNum: {
      // These options are passed to Intl.NumberFormat
      style: "decimal",
      minimumSignificantDigits: 6,
      maximumSignificantDigits: 6,
    },
  },
  "ar-EG": {
    mainNum: {
      style: "decimal",
      minimumSignificantDigits: 1,
      maximumSignificantDigits: 14,
      useGrouping: false,
    },
  },
};
